module.exports = __webpack_public_path__ + "static/banner-3a7292a36bb08f21fc0759e9813eda19.jpg";